/* 🤖 this file was generated by svg-to-ts */
export const matIconAssistant: {
  name: 'assistant';
  data: string;
} = {
  name: 'assistant',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4h14v14zm-7-1 1.88-4.12L18 11l-4.12-1.88L12 5l-1.88 4.12L6 11l4.12 1.88z"/></svg>`
};
